module.exports = __webpack_public_path__ + "img/case66.35026689.png";